import Vue from 'vue'
import App from './App.vue'
import router from './router'
import MetaInfo from 'vue-meta-info'
import axios from 'axios'

import '@/assets/css/app.css'
import '@/assets/css/mbapp.css'
import '@/assets/css/animate.css'
import '@/assets/css/swiper.css'
import '@/assets/iconfont/iconfont.css'

import Viewer from 'v-viewer' // 引入js
import 'viewerjs/dist/viewer.css' // 引入css
Vue.use(Viewer);
import wow from '@/assets/js/wow.min.js';
Vue.prototype.$wow=wow;


//用于设置title、描述、关键字，解决SEO的问题
Vue.use(MetaInfo);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false
axios.defaults.baseURL = 'https://zhongbangbang.uxphp.net';
// axios.defaults.baseURL = 'https://lab.uxphp.net';
new Vue({
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app')

